import { createFileRoute } from '@tanstack/react-router';
import { toolHead } from '../../../lib/toolHead';
import { YoutubeChannelTranscriptsPage } from '../../../pages/tools/creator-tools/YoutubeChannelTranscriptsPage';

export const Route = createFileRoute('/_site/tools/youtube-channel-transcripts')({
  head: () => toolHead('youtube-channel-transcripts'),
  component: YoutubeChannelTranscriptsPage,
});
